<template>
    <SectionBase class="LifekillsSection" :title="title" :text="text">
        <template v-slot:items>
            <DashboardLifeskillItem
                v-for="lifeskillId of lifeskillIds"
                :key="lifeskillId"
                :lifeskill-id="lifeskillId"
                :show-numbershape="showNumbershape"
            />
        </template>
    </SectionBase>
</template>

<script>
import SectionBase from './SectionBase';
import DashboardLifeskillItem from './DashboardLifeskillItem';

export default {
    components: { SectionBase, DashboardLifeskillItem },
    props: {
        lifeskillIds: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        text: {
            type: String
        },
        showNumbershape: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style lang="scss" scoped>
.DashboardLifeskillItem {
    width: (168em / 15);
    height: (240em / 15);
}

@include media('>=mobile') {
    .DashboardLifeskillItem {
        width: (168em / 15 * 1.1);
        height: (240em / 15 * 1.1);
    }
}
</style>
